// Browser-side Supabase client. The anon key is intentionally public — it
// only allows the operations RLS lets unauthenticated users do (≈ nothing
// in our model). The session token (after signin) is what unlocks per-
// user access via auth.uid() in RLS.
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Fail loud at startup rather than at first auth call.
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required. " +
      "Copy .env.example to .env and fill them in.",
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // for the email-confirm redirect
  },
});
